import FriendListItem from "./FriendListItem";

function FriendList({ friends }) {
  return (
    <ul>
      {friends.map(friend => (
        <FriendListItem key={friend.id} friend={friend} />
      ))}
    </ul>
  );
}

export default FriendList;